import * as React from 'react';
import styled, {css} from 'styled-components';
import PropTypes from 'prop-types';
import media from "../styles/media";
import {Typography} from './typography';
import ContentBlock from "./content-block";
import {Container} from "react-bulma-components";
import Media from "./media/media";


const Heading = styled.div`
`;

const SupTitle = styled.h2`
  ${Typography.SupHeadingMixin};
  margin-bottom: 0.4em;
`;

const TitleH2 = styled.h2`
  ${Typography.SectionHeadingMixin};
`;

const TitleH3 = styled.h3`
  ${Typography.SectionHeadingMixin};
`;

const Body = styled.article`
  font-size: 1rem;
  
  &:not(:last-child) {
    margin-bottom: 1rem;
  }
  
  ${media.from.tablet(css`
    overflow-wrap: break-word;
    hyphens: auto;
    font-size: 1.2rem;
  `)}
`;

const MediaColumn = styled.div`
  flex: 1.2;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledMedia = styled(Media)`
  max-height: 500px;
`;

const ContentColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
`;

const InnerLayout = styled.div<{$contentPosition?: 'right' | 'left'}>`
  display: flex;
  flex-direction: column;

  ${MediaColumn} {
    margin-bottom: 2em;
  }

  ${media.from.tablet(css`
    flex-direction: row;

    ${ContentColumn} {
      order: ${props => props.$contentPosition === 'right' ? 2 : 1};
    }

    ${MediaColumn} {
      margin-bottom: 0;
      ${props => props.$contentPosition === 'right'
              ? css({order: 1, 'margin-right': '40px'})
              : css({order: 2, 'margin-left': '40px'})}
    }
  `)}
`;

interface Props {
  contentPosition?: 'right' | 'left';
  [x: string]: any;
}

const HorizontalContentBlock =
  ({
     contentPosition = 'right',
     media = undefined,
     supTitle = undefined,
     title = undefined,
     content = undefined,
     footer = null,
     mode = 'transparent',
     titleElement = undefined,
     ...props
   }: Props) => {

    // when supTitle is provided, it is assumed to be a `h2` and title will be `h3`
    // otherwise, title is the `h2`
    if (supTitle && typeof supTitle === 'string') {
      supTitle = (<SupTitle>{supTitle}</SupTitle>)
    }
    if (title && typeof title === 'string') {
      const TitleElement = titleElement ?? (supTitle ? TitleH3 : TitleH2);
      title = (<TitleElement>{title}</TitleElement>)
    }

    if (media && !React.isValidElement(media)) {
      media = <StyledMedia {...media} />
    }
    return (
      <ContentBlock mode={mode} {...props} fullWidth={true}>
        <Container>
          <InnerLayout $contentPosition={contentPosition}>
            <MediaColumn>
              {media}
            </MediaColumn>
            <ContentColumn>
              <Heading>
                {supTitle}
                {title}
              </Heading>

              <Body>
                {content}
              </Body>
              {footer}
            </ContentColumn>
          </InnerLayout>
        </Container>
      </ContentBlock>
    )
  }


HorizontalContentBlock.propTypes = {
    ...ContentBlock.propTypes,
    title: PropTypes.node,
    content: PropTypes.node,
    footer: PropTypes.node,
    media: PropTypes.node,
    contentPosition: PropTypes.oneOf(['left', 'right']),
}

export default HorizontalContentBlock;
